import { FormEvent } from "react";
import { UseFormReturn } from "react-hook-form";

import FormLabel from "~/components/login/formLabel/FormLabel";
import Button from "~/components/mantine/button/Button";
import Notification from "~/components/notificationBlock/NotificationBlock";
import Input from "~/components/ui/input/Input";
import labels from "~/helpers/labels";

import { FormValues } from "../WithSubscription";
import styles from "./styles.module.scss";

type CancelationFormContentProps = {
  subscriptionEndDate: string;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
  form: UseFormReturn<FormValues>;
  standbyable?: string | null;
  onTurnOnStandby?: () => void;
  isStandbyPending?: boolean;
};

const CancelationFormContent = ({
  subscriptionEndDate,
  onSubmit,
  form,
  standbyable,
  onTurnOnStandby,
  isStandbyPending,
}: CancelationFormContentProps) => {
  const { register } = form;

  return (
    <>
      <p className={styles.modalText}>
        {labels.CANCELATION_MESSAGE(subscriptionEndDate)}
      </p>
      {/*
       // @ts-expect-error TS2339 non-existing className */}
      <div className={styles.modalNotification}>
        <Notification type="warning" message={labels.CANCELATION_WARNING} />
      </div>
      {standbyable && (
        <>
          <p className={styles.modalText}>{standbyable}</p>
          <Button loading={isStandbyPending} onClick={onTurnOnStandby}>
            Turn On Standby Mode
          </Button>
        </>
      )}
      <form id="cancelationModalForm" onSubmit={onSubmit}>
        <div className={styles.modalInputWrapper}>
          <FormLabel label={labels.CANCEL_CONFIRMATION} />
          <Input
            placeholder={labels.TYPE_CANCELATION_PLACEHOLDER}
            {...register("confirmation", { required: true })}
          />
        </div>
      </form>
    </>
  );
};

export default CancelationFormContent;
